import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { documentDownload, getDocumentList } from "../../../actions/AuthorizationDetailsTab";
import LetterDecision from "../components/LetterDescision";
import { DocumentDownloadActionDispatchTypes } from "../../../models/DispatchTypes/AuthorizationDetailstab";

const mapStateToProps = ({
  documentListState,
  documentDownloadState
}: ApplicationState) => ({
  decisionLetterState: documentListState.response,
  documentDownloadData: documentDownloadState
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, DocumentDownloadActionDispatchTypes>
) => {
    return {
      getDecisionLetterList: (referralId: number,type:number) => {
        dispatch(getDocumentList(referralId,type));
      },
      documentDownload: (blobId: number) => {
        dispatch(documentDownload(blobId));
      },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LetterDecision);
